import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../enums';
import * as ticketsActions from '../../redux/tickets/actions';
import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import { enumHelper } from '../../utils';
import generateClassName from '../../utils/generateClassName';

class TicketsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketOpen: false,
      sortType: 'asc',
      selectedTicketId: null,
      status: '',
      isActive: false,
      sortedColumn: ''
    };
  }

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  renderStatusColors = status => {
    switch (status) {
      case 'PENDING':
        return 'text-warning';
      case 'RESPONDED':
        return 'text-success';
      case 'CLINET_RESPONSE':
        return 'text-info';
      case 'CLOSED':
        return 'text-muted';
      default:
        return 'text-dark';
    }
  };

  render() {
    let {
      ticketsList = [],
      pageNumber,
      pageSize,
      sortType,

      ticketsLoading,
      ticketsMessage,
      ticketsError,
      ticketsFailed
    } = this.props;
    return (
      <>
        <Spin spinning={ticketsLoading}>
          {ticketsError && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
          {ticketsFailed && <div className="alert alert-danger">{ticketsMessage}</div>}
          <table className="table table-hover table-light table-striped">
            <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th onClick={() => this.sortTable('title')} className="text-center pointer">
                  <i name="title" className={generateClassName('title', this.state.sortedColumn, sortType)} />
                  {locales('tables.title')}
                </th>
                <th onClick={() => this.sortTable('createdFullName')} className="text-center pointer">
                  <i
                    name="createdFullName"
                    className={generateClassName('createdFullName', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.creator')}
                </th>
                <th onClick={() => this.sortTable('lastUpdatedAt')} className="text-center pointer">
                  <i
                    name="lastUpdatedAt"
                    className={generateClassName('lastUpdatedAt', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.lastUpdate')}
                </th>
                <th className="text-center">{locales('tables.status')}</th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody>
              {ticketsList.length ? (
                ticketsList.map((ticket, index) => (
                  <tr key={ticket.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td title={ticket.title} className="text-center">
                      {ticket.title}
                    </td>
                    <td className="text-center">{ticket.createdFullName}</td>
                    <td className={`text-center`}>{ticket.lastUpdatedAt}</td>
                    <td className={`text-center ${this.renderStatusColors(ticket.status)}`}>
                      {enumHelper.convertEnumValueToTitle(ENUMS.TICKETS_STATUS.list, ticket.status)}
                    </td>
                    <td className={`text-center`}>
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_TICKET_DETAILS}>
                        <NavLink
                          to={{
                            pathname: '/ticket/details',
                            ticketId: ticket.id
                          }}
                        >
                          <i
                            title={locales('titles.ticketDetails')}
                            className="text-center far fa-info-circle text-success pointer"
                          />
                        </NavLink>
                      </ShowForPermission>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    ticketsList: state.ticketsReducer.ticketsList,
    tickets: state.ticketsReducer.tickets,
    ticketsFailed: state.ticketsReducer.ticketsFailed,
    ticketsError: state.ticketsReducer.ticketsError,
    ticketsMessage: state.ticketsReducer.ticketsMessage,
    ticketsLoading: state.ticketsReducer.ticketsLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllTickets: query => dispatch(ticketsActions.fetchAllTickets(query))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TicketsTable)
);
